import type { SearchRequest } from '@kimuno/api-sdk/lib/types/requests/Common';
import type { SearchResponseData } from '@kimuno/api-sdk/lib/types/responses/Common';
import type { MindItemSearchResult } from '@kimuno/api-sdk/lib/types/responses/MindItem';

import services from '../services';
import type { SearchFilters } from '../types/search';
import type { ThunkAction } from './common.actionTypes';
import {
	FETCH_DASHBOARD_WORKSHEETS,
	type FetchDashboardWorksheetsAction,
} from './dashboard.actionTypes';

export const DASHBOARD_WORKSHEETS_LIMIT = 20;

// Worksheet pages only — stricter than the search "Arbeitsblätter" tab
// (contentType=document); scopes literally to worksheet pages.
const WORKSHEET_FILTERS: Pick<SearchFilters, 'pageContentType' | 'sortBy'> = {
	pageContentType: ['arbeitsblatt'],
	sortBy: 'createdDate',
};

/**
 * Fetches the newest worksheet mind items across the given subjects into the
 * dashboard-scoped slice, isolated from the search page's global mind-item store.
 * No-op when no subjects are supplied.
 */
export function fetchDashboardWorksheets(
	subjects: string[]
): ThunkAction<FetchDashboardWorksheetsAction> {
	return async (dispatch) => {
		if (subjects.length === 0) return;

		const request: SearchRequest = {
			...WORKSHEET_FILTERS,
			subject: subjects,
			offset: 0,
			limit: DASHBOARD_WORKSHEETS_LIMIT,
		};
		const payload = { subjects };

		dispatch({ type: FETCH_DASHBOARD_WORKSHEETS.START, payload });

		return services.mindItem
			.search(request)
			.then((result) => {
				dispatch({
					type: FETCH_DASHBOARD_WORKSHEETS.SUCCESS,
					result: result as SearchResponseData<MindItemSearchResult>,
					payload,
				});
			})
			.catch((error) => {
				dispatch({ error, type: FETCH_DASHBOARD_WORKSHEETS.ERROR, payload });
			});
	};
}
